import { useNotification } from "../context/NotificationContext";
import { EventRegistration } from "../types/shared.types";

const useRegistrationSearch = (
  setSearchResults: React.Dispatch<
    React.SetStateAction<EventRegistration[] | null>
  >,
  allRegistrations: EventRegistration[],
  resetPagination: () => void,
  eventNameMap: Record<string, string> = {},
) => {
  const { setNotification } = useNotification();

  const handleSearch = (query: string) => {
    const trimmedQuery = query.trim().toLowerCase();

    if (!trimmedQuery) {
      setSearchResults(null);
      resetPagination();
      return;
    }

    try {
      const results = allRegistrations.filter((registration) => {
        const eventName = eventNameMap[registration.eventId]?.toLowerCase() || "";
        return (
          /*registration.userName.toLowerCase().includes(trimmedQuery) ||
          registration.userEmail.toLowerCase().includes(trimmedQuery) ||
          registration.registrationId.toLowerCase().includes(trimmedQuery) ||
          registration.eventId.toLowerCase().includes(trimmedQuery) ||
          registration.employeeId?.toLowerCase().includes(trimmedQuery) ||
          registration.checkInCode?.toLowerCase().includes(trimmedQuery) ||*/
          eventName.includes(trimmedQuery)
        );
      });

      setSearchResults(results);

      resetPagination();
    } catch (error: any) {
      setNotification({
        type: "error",
        message: error.message || "Sorry! Something went wrong.",
      });
    }
  };

  return { handleSearch };
};

export default useRegistrationSearch;